/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItem_portfolioItem$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItems_portfolioItems$ref: FragmentReference;
export type CartItems_portfolioItems = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +portfolioItemId: ?string,
      +item: ?{|
        +serviceId: ?string,
        +ecommerceTrackingParams: ?any,
      |},
      +$fragmentRefs: CartItem_portfolioItem$ref,
    |}
  |}>,
  +$refType: CartItems_portfolioItems$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItems_portfolioItems",
  "type": "PortfolioItemsConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PortfolioItemsEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfolioItemV2",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "CartItem_portfolioItem",
              "args": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "portfolioItemId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "ecommerceTrackingParams",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '91c7e9ba88ed8dd92898e35d78801a4b';
module.exports = node;
